<template>
    <v-dialog
        :retain-focus="false"
        :value="showCreate"
        persistent
        max-width="85%"
        @click:outside="closeModal"
    >
        <validation-observer v-slot="{ handleSubmit }">
            <div class="allotment-create-wrapper">
                <div class="allotment-create-header">
                    <span v-if="isCreate" class="allotment-create-name">
                        TẠO LỘ TRÌNH
                    </span>
                    <span v-else class="allotment-create-name">
                        SỬA LỘ TRÌNH
                    </span>
                    <v-icon
                        size="24" 
                        @click="closeModal"
                    >
                        mdi-close
                    </v-icon>
                </div>
                <div class="allotment-create-form">
                    <div class="input-form">
                        <div class="allotment-create-label pt-3">
                            Tên Lộ Trình *
                        </div>
                        <div class="input-wrapper col py-0 pl-7">
                            <validation-provider
                                v-slot="{ errors }"
                                rules="required"
                                name="Tên Lộ Trình"
                            >
                                <v-text-field
                                    class="allotment-create-input"
                                    placeholder="Nhập tên lộ trình..."
                                    v-model="allotment.name"
                                    :error-messages="errors"
                                />
                            </validation-provider>
                        </div>
                    </div>

                    <div class="input-form">
                      <v-col cols="12" md="6" class="d-flex px-0">
                        <div class="allotment-create-label pt-6 w-20">
                          Loại hình *
                        </div>
                        <div class="input-wrapper col py-0 pl-7">
                          <validation-provider
                              v-slot="{ errors }"
                              class="mb-2"
                              rules="required"
                              name="Loại hình"
                          >
                            <v-autocomplete
                                v-model="allotment.typeId"
                                :items="listType"
                                item-text="name"
                                item-value="id"
                                :error-messages="errors"
                                readonly
                            />
                          </validation-provider>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" class="d-flex">
                        <div class="allotment-create-label pt-6 w-30">
                          Ngành *
                        </div>
                        <div class="input-wrapper col py-0 pl-7">
                          <validation-provider
                            v-slot="{ errors }"
                            class="mb-2"
                            rules="required"
                            name="Ngành"
                          >
                            <v-autocomplete
                              v-model="allotment.schoolLevelId"
                              :items="listSchoolLevelByType"
                              item-text="name"
                              item-value="id"
                              :error-messages="errors"
                              @change="getListProductFilter"
                              readonly
                              placeholder="Nhóm ngành"
                            />
                          </validation-provider>
                        </div>
                      </v-col>
                    </div>

                    <div class="input-form">
                      <v-col cols="12" md="6" class="d-flex px-0">
                        <div class="allotment-create-label pt-6 w-20">
                          Kho *
                        </div>
                        <div class="input-wrapper col py-0 pl-7">
                          <validation-provider
                              v-slot="{ errors }"
                              class="mb-2"
                              rules="required"
                              name="Kho"
                          >
                            <v-autocomplete
                                v-model="allotment.store"
                                :items="storeStocks"
                                item-text="name"
                                item-value="value"
                                label="Chọn kho"
                                @change="changeStore"
                                :error-messages="errors"
                            />
                          </validation-provider>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" class="d-flex">
                        <div class="allotment-create-label pt-6 w-30">
                          Nhóm sản phẩm
                        </div>
                        <div class="input-wrapper col py-0 pl-7">
                          <validation-provider
                              v-slot="{ errors }"
                              class="mb-2"
                              name="Nhóm sản phẩm"
                          >
                            <v-autocomplete
                                v-model="allotment.productGroups"
                                :items="productGroupsFilter"
                                :error-messages="errors"
                                item-text="name"
                                item-value="id"
                                color="primary"
                                multiple
                                class="selectAll-group-product"
                                clearable
                                :disabled="!allotment.schoolLevelId"
                                eager
                            >
                              <template #prepend-item>
                                <common-select-all
                                    v-model="allotment.productGroups"
                                    :item="allotment.productGroups"
                                    :items="productGroups.map(s => s.id)"
                                ></common-select-all>
                              </template>
                            </v-autocomplete>
                          </validation-provider>
                        </div>
                      </v-col>
                    </div>

<!--                    <div class="input-form">-->
<!--                      <v-col cols="12" md="6" class="d-flex px-0">-->
<!--                        <div class="allotment-create-label pt-6 w-20">-->
<!--                          Lộ trình làm việc-->
<!--                        </div>-->
<!--                        <div class="input-wrapper col py-0 pl-7">-->
<!--                          <validation-provider-->
<!--                              v-slot="{ errors }"-->
<!--                              class="mb-2"-->
<!--                              name="Chọn lộ trình làm việc"-->
<!--                          >-->
<!--                            <v-autocomplete-->
<!--                                v-model="allotment.rankIds"-->
<!--                                :items="listRankForSelect"-->
<!--                                :error-messages="errors"-->
<!--                                item-text="name"-->
<!--                                item-value="id"-->
<!--                                label="Chọn chọn lộ trình"-->
<!--                                color="primary"-->
<!--                                multiple-->
<!--                                class="selectAll-group-product"-->
<!--                                clearable-->
<!--                                eager-->
<!--                            >-->
<!--                              <template #prepend-item>-->
<!--                                <common-select-all-->
<!--                                    v-model="allotment.productGroups"-->
<!--                                    :item="allotment.productGroups"-->
<!--                                    :items="productGroups.map(s => s.id)"-->
<!--                                ></common-select-all>-->
<!--                              </template>-->
<!--                            </v-autocomplete>-->
<!--                          </validation-provider>-->
<!--                        </div>-->
<!--                      </v-col>-->
<!--                    </div>-->

                    <div class="input-form">
                      <div class="allotment-create-label pt-5">
                        Chọn Nguồn *
                      </div>
                      <div
                          style="position: relative"
                          class="col py-0 pl-9">
                        <validation-provider
                            v-slot="{ errors }"
                            rules="required"
                            name="Nguồn"
                            class="d-flex flex-wrap"
                        >
                          <div
                              v-for="source in contactStatusFilter"
                              style="flex: 0 0 33.333333%;">
                            <v-checkbox
                                style="width: fit-content; display: inline-block;"
                                color="#52B141"
                                v-model="allotment.sourcesIds"
                                @change="changeSources(source.id)"
                                :value="source.id"
                                :disabled="!allotment.store"
                            ></v-checkbox>
                            <span>{{ source.name }}</span>
                          </div>
                          <span class="error-required-checkbox" v-if="errors.length">
                            {{errors[0]}}
                          </span>
                        </validation-provider>
                      </div>
                    </div>

                    <div class="input-form">
                      <div
                          style="width: 13%"
                          class="allotment-create-label">
                        Chỉ số phân bổ *
                      </div>
                      <div style="width: 85%">
                        <v-simple-table
                            class="border-table table-index"
                        >
                          <template v-slot:default>
                            <thead>
                            <tr class="item-table-header">
                              <th rowspan="2" class="text-center">Nguồn</th>
                              <th class="text-center" colspan="2">Sáng</th>
                              <th class="text-center" colspan="2">Chiều</th>
                              <th class="text-center" colspan="2">Tối</th>
                            </tr>
                            <tr class="item-table-sub-header">
                              <th class="text-center">Tổng</th>
                              <th class="text-center">Phân bổ</th>
                              <th class="text-center">Tổng</th>
                              <th class="text-center">Phân bổ</th>
                              <th class="text-center">Tổng</th>
                              <th class="text-center">Phân bổ</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(itemSource, index) in allotment.sources">
                              <td class="text-center">{{ itemSource.name }}</td>
                              <td v-if="index == 0"
                                  class="text-center"
                                  :rowspan="allotment.sources.length"
                                  >
<!--                                <div v-if="allotment.showEdit.total_m">-->
<!--                                  <validation-provider-->
<!--                                      v-slot="{ errors }"-->
<!--                                      :rules="{required: isRequired, numeric: true, regex: /^[0-9]*$/, min_value: 0, max_value: 100}"-->
<!--                                      name="Giá trị"-->
<!--                                      class="d-flex flex-wrap"-->
<!--                                      :vid="`total_m_${allotment.id}`"-->
<!--                                  >-->
<!--                                    <v-text-field-->
<!--                                        v-model="allotment.total_m"-->
<!--                                        color="primary"-->
<!--                                        :error-messages="errors"-->
<!--                                    />-->
<!--                                  </validation-provider>-->
<!--                                </div>-->
                                <div>
                                  {{ allotment.total_m }}
                                </div>
                              </td>
                              <td
                                  class="text-center"
                                  @dblclick="beforeEdit(itemSource, 'numberOfContactM')">
                                <div v-if="itemSource.showEdit.numberOfContactM">
                                  <validation-provider
                                      v-slot="{ errors }"
                                      :rules="{required: isRequired, numeric: true, regex: /^[0-9]*$/, min_value: 0, max_value: 100}"
                                      name="Giá trị"
                                      class="d-flex flex-wrap"
                                      :vid="`numberOfContactM_${itemSource.statusId}_${allotment.id}`"
                                  >
                                    <v-text-field
                                        v-model="itemSource.numberOfContactM"
                                        color="primary"
                                        :error-messages="errors"
                                        @input="changeIndex('numberOfContactM')"
                                    />
                                  </validation-provider>
                                </div>
                                <div v-else>
                                  {{ itemSource.numberOfContactM }}
                                </div>
                              </td>
                              <td
                                  v-if="index == 0"
                                  class="text-center"
                                  :rowspan="allotment.sources.length"
                                  >
<!--                                <div v-if="allotment.showEdit.total_a">-->
<!--                                  <validation-provider-->
<!--                                      v-slot="{ errors }"-->
<!--                                      :rules="{required: isRequired, numeric: true, regex: /^[0-9]*$/, min_value: 0, max_value: 100}"-->
<!--                                      name="Giá trị"-->
<!--                                      class="d-flex flex-wrap"-->
<!--                                      :vid="`total_a_${allotment.id}`"-->
<!--                                  >-->
<!--                                    <v-text-field-->
<!--                                        v-model="allotment.total_a"-->
<!--                                        color="primary"-->
<!--                                        :error-messages="errors"-->
<!--                                    />-->
<!--                                  </validation-provider>-->
<!--                                </div>-->
                                <div>
                                  {{allotment.total_a}}
                                </div>
                              </td>
                              <td
                                  class="text-center"
                                  @dblclick="beforeEdit(itemSource, 'numberOfContactA')">
                                <div v-if="itemSource.showEdit.numberOfContactA">
                                  <validation-provider
                                      v-slot="{ errors }"
                                      :rules="{required: isRequired, numeric: true, regex: /^[0-9]*$/, min_value: 0, max_value: 100}"
                                      name="Giá trị"
                                      class="d-flex flex-wrap"
                                      :vid="`numberOfContactA_${itemSource.statusId}_${allotment.id}`"
                                  >
                                    <v-text-field
                                        v-model="itemSource.numberOfContactA"
                                        color="primary"
                                        :error-messages="errors"
                                        @input="changeIndex('numberOfContactA')"
                                    />
                                  </validation-provider>
                                </div>
                                <div v-else>
                                  {{ itemSource.numberOfContactA }}
                                </div>
                              </td>
                              <td
                                  class="text-center"
                                  v-if="index == 0"
                                  :rowspan="allotment.sources.length"
                                  >
<!--                                <div v-if="allotment.showEdit.total_e">-->
<!--                                  <validation-provider-->
<!--                                      v-slot="{ errors }"-->
<!--                                      :rules="{required: isRequired, numeric: true, regex: /^[0-9]*$/, min_value: 0, max_value: 100}"-->
<!--                                      name="Giá trị"-->
<!--                                      class="d-flex flex-wrap"-->
<!--                                      :vid="`total_e_${allotment.id}`"-->
<!--                                  >-->
<!--                                    <v-text-field-->
<!--                                        v-model="allotment.total_e"-->
<!--                                        color="primary"-->
<!--                                        :error-messages="errors"-->
<!--                                    />-->
<!--                                  </validation-provider>-->
<!--                                </div>-->
                                <div>
                                  {{allotment.total_e}}
                                </div>
                              </td>
                              <td
                                  class="text-center"
                                  @dblclick="beforeEdit(itemSource, 'numberOfContactE')">
                                <div v-if="itemSource.showEdit.numberOfContactE">
                                  <validation-provider
                                      v-slot="{ errors }"
                                      :rules="{required: isRequired, numeric: true, regex: /^[0-9]*$/, min_value: 0, max_value: 100}"
                                      name="Giá trị"
                                      class="d-flex flex-wrap"
                                      :vid="`numberOfContactE_${itemSource.statusId}_${allotment.id}`"
                                  >
                                    <v-text-field
                                        v-model="itemSource.numberOfContactE"
                                        color="primary"
                                        :error-messages="errors"
                                        @input="changeIndex('numberOfContactE')"
                                    />
                                  </validation-provider>
                                </div>
                                <div v-else>
                                  {{ itemSource.numberOfContactE }}
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </div>
                    </div>
                </div>
                <div class="col text-center">
                    <button
                        class="cancel-btn"
                        @click="closeModal"
                    >
                        BỎ QUA
                    </button>
                    <button
                        :disabled="loading"
                        class="accept-btn"
                        @click="handleSubmit(saveAllotment)"
                    >
                        LƯU
                    </button>
                </div>
            </div>
        </validation-observer>
    </v-dialog>
</template>

<script>
import moment from 'moment'
export default {
    props: {
      showCreate: {
          type: Boolean,
          default: false
      },
      isCreate: {
          type: Boolean,
          default: true
      },
      storeStocks: {
          type: Array,
          default: () => {[]}
      },
      listSchoolLevel: {
          type: Array,
          default: () => {[]}
      },
      listType: {
          type: Array,
          default: () => {[]}
      },
      allotment: {
        type: Object,
        default: () => {}
      },
      productGroups: {
        type: Array,
        default: () => {[]}
      },
      contactStatusList: {
        type: Array,
        default: () => {[]}
      },
      loading: {
        type: Boolean,
        default: false
      },
      listRankForSelect: {
        type: Array,
        default: () => {[]}
      }
    },

    data() {
      return {
        productGroupsFilter: [],
        contactStatusFilter: [],
        isRequired: true
      }
    },
    created() {
      this.getListProductFilter();

      if(this.allotment.store) {
        let storeStatus = `${this.allotment.store}0`
        this.contactStatusFilter = this.contactStatusList.filter(status => status.type.includes(storeStatus))
      }

      this.isRequired = !this.allotment.total_m && !this.allotment.total_a && !this.allotment.total_e
    },
    computed:{
      listSchoolLevelByType(){
        if(this.listSchoolLevel.length > 0 && this.allotment.typeId){
            const result = this.listSchoolLevel.find(school => school.id === this.allotment.typeId)
            return result.schoolLevel
        }else return []
      }
    },
    methods: {
      closeModal() {
          Bus.$emit('close-create-allotment-modal')
      },

      saveAllotment() {
        Bus.$emit('save-allotment', this.allotment)
      },
      getListProductFilter() {
        if(this.allotment.schoolLevelId) {
          this.productGroupsFilter = this.productGroups.filter(item => this.allotment.schoolLevelId == item.schoolLevelId
            || this.allotment.productGroups.includes(item.id)
          )
        } else {
          this.productGroupsFilter = this.productGroups
        }
      },
      beforeEdit(itemEdit, param) {
        itemEdit.showEdit[param] = !itemEdit.showEdit[param];
      },
      changeSources(sourceId) {
        if(this.allotment.sourcesIds.includes(sourceId)) {
          let index = this.contactStatusList.findIndex(ite => ite.id === sourceId)
          if(index > -1) {
            const itemFound = this.contactStatusList[index];

            let itemSourceTemp = {
              numberOfContactM: '',
              numberOfContactA: '',
              numberOfContactE: '',
              showEdit: {
                numberOfContactM: true,
                numberOfContactA: true,
                numberOfContactE: true
              }
            }
            itemSourceTemp.statusId = itemFound.id
            itemSourceTemp.name = itemFound.name
            this.allotment.sources.push(itemSourceTemp)
          }
        } else {
          let index = this.allotment.sources.findIndex(ite => ite.statusId === sourceId)
          if(index > -1) {
            this.allotment.sources.splice(index, 1);

            // Tinh toan lai total
            this.allotment.total_m = 0;
            this.allotment.total_a = 0;
            this.allotment.total_e = 0;
            this.allotment.sources.forEach(itemS => {
              this.allotment.total_m += itemS.numberOfContactM;
              this.allotment.total_a += itemS.numberOfContactA;
              this.allotment.total_e += itemS.numberOfContactE;
            })
          }
        }
      },
      changeStore() {
        this.allotment.sourcesIds = []
        this.allotment.sources = []
        let storeStatus = `${this.allotment.store}0`
        this.contactStatusFilter = this.contactStatusList.filter(status => status.type.includes(storeStatus))
      },
      changeIndex(property) {
        let totalChange = '';
        switch (property) {
          case 'numberOfContactM':
            totalChange = 'total_m'
            break;
          case 'numberOfContactA':
            totalChange = 'total_a'
            break;
          case 'numberOfContactE':
            totalChange = 'total_e'
            break;
        }

        this.allotment[totalChange] = this.allotment.sources.reduce( (total, item) => {
          return total + (+item[property]);
        }, 0)
        this.isRequired = !this.allotment.total_m && !this.allotment.total_a && !this.allotment.total_e
      }
    }
}
</script>

<style scoped>
  .allotment-create-wrapper {
      background-color: white;
      border-radius: 8px;
      box-shadow: 0px 6px 24px rgba(0, 0, 0, 0.1);
  }

  .allotment-create-header {
      padding: 15px 0px;
      margin: 0px 20px 0px 30px;
      border-bottom: 1px solid #E0E0E0;
  }

  .allotment-create-header i {
      float: right;
      cursor: pointer;
  }

  .allotment-create-name {
      font-size: 20px;
      font-weight: 600;
  }

  .allotment-create-label {
      font-size: 16px;
  }

  .input-form {
      display: flex;
      width: 100%;
      padding: 10px 20px 25px 30px;
  }

  .input-wrapper {
      height: 48px;
  }

  .allotment-create-input {
      width: 100%;
      background-color: #F8F8F8;
      height: 100%;
      padding: 5px 20px;
      font-size: 16px;
      outline: unset;
      border-radius: 8px;
  }

  .allotment-create-add {
      width: 48px;
      height: 48px;
      background-color: white;
      border: 1px dashed #BDBDBD;
      border-radius: 8px;
  }

  .allotment-create-add i {
      color: black;
      font-size: 24px;
  }

  .cancel-btn {
      background-color: #F2F2F2;
      width: 160px;
      height: 48px;
      font-size: 16px;
      color: #828282;
      font-weight: 700;
      border-radius: 8px;
      margin-right: 24px;
  }

  .accept-btn {
      background-color: #7367F0;
      width: 160px;
      height: 48px;
      font-size: 16px;
      color: white;
      font-weight: 700;
      border-radius: 8px;
  }
  .item-table-header {
    background: #6C4EAD;
  }
  .item-table-header th {
    color: white !important;
    font-weight: bold;
  }
  .item-table-sub-header th {
    font-weight: bold !important;
  }
  .w-30 {
    min-width: 119px;
  }
  .w-20 {
    min-width: 103px;
  }
  .error-required-checkbox {
    position: absolute;
    color: red;
    font-size: 12px;
    bottom: 4px;
    left: 41px;
  }
  tbody tr td {
    width: 100px;
    height: 45px;
  }
  /deep/.table-index .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
    height: 21px;
  }
  /deep/.table-index .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot > input {
    text-align: center;
  }
  /deep/.table-index .theme--light.v-input {
    padding-top: 0px !important;
  }
</style>